import { Column } from '@synqo/frontend-component-library';
import { ApiInvoiceEmailDelivery, emailStateOptions, EnumEmailState, getEnumEmailStateLabel } from '@Model';

export const emailDeliveryColumns: Column<ApiInvoiceEmailDelivery>[] = [
    {
        name: 'sent_date',
        label: 'Datum',
        type: 'datetime',
    },
    {
        name: 'recipient',
        label: 'Empfänger',
    },
    {
        name: 'email_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: emailStateOptions,
        renderCell: ({ cellData }) => getEnumEmailStateLabel(cellData as EnumEmailState),
    },
];
